// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
//import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB8FDfSsFbjBH7uHWcAxg9D2DWQpuVAQyA",
  authDomain: "smart-pln-mobile.firebaseapp.com",
  projectId: "smart-pln-mobile",
  storageBucket: "smart-pln-mobile.firebasestorage.app",
  messagingSenderId: "1074082194543",
  appId: "1:1074082194543:web:069abf55fb967ca290199a",
  measurementId: "G-10Q706GEQ2"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
//const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);


export {auth, db}